// client/src/services/printerSettingsService.js
import axios from 'axios';

const API_URL = '/api/printers';

const printerSettingsService = {
  // Récupérer tous les paramètres d'impression
  getAllPrinterSettings: async () => {
    try {
      const response = await axios.get(`${API_URL}/settings`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des paramètres d\'impression:', error);
      throw error;
    }
  },

  // Récupérer les paramètres d'une station spécifique
  getPrinterSettings: async (stationId) => {
    try {
      const response = await axios.get(`${API_URL}/settings/${stationId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des paramètres d\'impression:', error);
      throw error;
    }
  },

  // Mettre à jour les paramètres d'une station
  updatePrinterSettings: async (stationId, settings) => {
    try {
      const response = await axios.put(`${API_URL}/settings/${stationId}`, settings);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour des paramètres d\'impression:', error);
      throw error;
    }
  },

  // Supprimer une configuration
  deletePrinterSettings: async (stationId) => {
    try {
      const response = await axios.delete(`${API_URL}/settings/${stationId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression des paramètres d\'impression:', error);
      throw error;
    }
  },

  // Obtenir la configuration legacy
  getLegacyConfig: async () => {
    try {
      const response = await axios.get(`${API_URL}/config`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la configuration legacy:', error);
      throw error;
    }
  },

  // Migrer depuis la configuration legacy
  migrateFromLegacy: async (legacyConfig) => {
    try {
      const response = await axios.post(`${API_URL}/migrate`, { legacyConfig });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la migration depuis la configuration legacy:', error);
      throw error;
    }
  },

  // Détecter les imprimantes disponibles
  detectPrinters: async () => {
    try {
      const response = await axios.get(`${API_URL}/list`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la détection des imprimantes:', error);
      throw error;
    }
  }
};

export default printerSettingsService;

// // // // client/src/services/printerSettingsService.js
// // // import axios from 'axios';

// // // const API_URL = '/api/printer-settings';

// // // /**
// // //  * Service pour gérer les opérations liées aux paramètres d'impression
// // //  */
// // // const printerSettingsService = {
// // //   /**
// // //    * Récupérer les paramètres d'impression d'une station
// // //    * @param {string} stationId - Identifiant unique de la station
// // //    * @returns {Promise} Promesse résolue avec les données des paramètres
// // //    */
// // //   getPrinterSettings: async (stationId) => {
// // //     try {
// // //       const response = await axios.get(`${API_URL}/${stationId}`);
// // //       return response.data;
// // //     } catch (error) {
// // //       console.error('Erreur lors de la récupération des paramètres d\'impression:', error);
// // //       throw error;
// // //     }
// // //   },

// // //   /**
// // //    * Mettre à jour les paramètres d'impression d'une station
// // //    * @param {string} stationId - Identifiant unique de la station
// // //    * @param {Object} settings - Paramètres d'impression à mettre à jour
// // //    * @returns {Promise} Promesse résolue avec les données mises à jour
// // //    */
// // //   updatePrinterSettings: async (stationId, settings) => {
// // //     try {
// // //       const response = await axios.put(`${API_URL}/${stationId}`, settings);
// // //       return response.data;
// // //     } catch (error) {
// // //       console.error('Erreur lors de la mise à jour des paramètres d\'impression:', error);
// // //       throw error;
// // //     }
// // //   },

// // //   /**
// // //    * Récupérer tous les paramètres d'impression (pour admin)
// // //    * @returns {Promise} Promesse résolue avec la liste des paramètres
// // //    */
// // //   getAllPrinterSettings: async () => {
// // //     try {
// // //       const response = await axios.get(API_URL);
// // //       return response.data;
// // //     } catch (error) {
// // //       console.error('Erreur lors de la récupération de tous les paramètres d\'impression:', error);
// // //       throw error;
// // //     }
// // //   },

// // //   /**
// // //    * Supprimer les paramètres d'impression d'une station
// // //    * @param {string} stationId - Identifiant unique de la station
// // //    * @returns {Promise} Promesse résolue avec un message de confirmation
// // //    */
// // //   deletePrinterSettings: async (stationId) => {
// // //     try {
// // //       const response = await axios.delete(`${API_URL}/${stationId}`);
// // //       return response.data;
// // //     } catch (error) {
// // //       console.error('Erreur lors de la suppression des paramètres d\'impression:', error);
// // //       throw error;
// // //     }
// // //   }
// // // };

// // // export default printerSettingsService;